/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuvisiblebadge2Inputs */

const en_menuvisiblebadge2 = /** @type {(inputs: Menuvisiblebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible to guests`)
};

const de_menuvisiblebadge2 = /** @type {(inputs: Menuvisiblebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Gäste sichtbar`)
};

/**
* | output |
* | --- |
* | "Visible to guests" |
*
* @param {Menuvisiblebadge2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuvisiblebadge2 = /** @type {((inputs?: Menuvisiblebadge2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuvisiblebadge2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuvisiblebadge2(inputs)
	return de_menuvisiblebadge2(inputs)
});
export { menuvisiblebadge2 as "menuVisibleBadge" }